import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientAddress from 'utils/print/getPatientAddress';
import getPatientCity from 'utils/print/getPatientCity';
import getPatientState from 'utils/print/getPatientState';
import getPatientZip from 'utils/print/getPatientZip';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientFullPhone from 'utils/print/getPatientFullPhone';
import getInsuranceID from 'utils/print/getInsuranceID';
import getPrescriberName from 'utils/print/getPrescriberName';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineDescription from 'utils/print/getOrderLineDescription';
import getOrderLineModel from 'utils/print/getOrderLineModel';
import getOrderLineCharge from 'utils/print/getOrderLineCharge';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineTotalCharge from 'utils/print/getOrderLineTotalCharge';
import getOrderTotalCharge from 'utils/print/getOrderTotalCharge';
import getSignature from 'utils/print/getSignature';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getBusinessStreet from 'utils/print/getBusinessStreet';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getBusinessCityStateZip from 'utils/print/getBusinessCityStateZip';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getFacilityPhone from 'utils/print/getFacilityPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getFacilityFax from 'utils/print/getFacilityFax';
import getOrderLineDriverFullName from 'utils/print/getOrderLineDriverFullName';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketDeliveryInstructionsAndReceipt = {
  ID: 44,
  Name: 'Delivery Instruction Package (Old Version)',
  Type: 'Delivery Ticket',
  Format: 'letter',
  OrderLineMax: 8,
  WithCharge: true,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-Delivery-Instructions-And-Receipt-Old/1.js',
      Logo: {
        x: 17,
        y: 12,
        width: 50,
        height: 20,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 108,
          y: 5,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props) || getBusinessStreet(props),
          x: 159,
          y: 15,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props) || getBusinessCityStateZip(props),
          x: 159,
          y: 18,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => getFacilityPhone(props) ? `Tel: ${getFacilityPhone(props)}` : `Tel: ${getBusinessPhone(props)}`,
          x: 159,
          y: 21,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => getFacilityFax(props) ? `Fax: ${getFacilityFax(props)}` : `Fax: ${getBusinessFax(props)}`,
          x: 159,
          y: 24,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Legal Notice 1',
          getText: (props) => {
            const businessName = getFacilityName(props) || getBusinessName(props);
            return `1. Assignment of Medicare, Medicaid, Medicare Supplemental or other insurance benefits to ${businessName} for medical supplies furnished to me by ${businessName}.
2. Direct billing to Medicare, Medicaid, Medicare Supplemental or other insurer(s).
3. Release of my medical information to Medicare, Medicaid, Medicare Supplemental or other insurer's and their agents and assigns.
4. ${businessName} to obtain medical or other information necessary in order to process my claim(s), including determining eligibility and seeking reimbursement for medical supplies and/or medication(s) provided.
5. ${businessName} to contact me by telephone or mail regarding my medical supplies order.
I request that payment to Medicare, Medicaid, Medicare Supplemental or other insurance benefits be made on my behalf to ${businessName} or its affiliates, for any medical supplies and/or medications furnished to me by ${businessName}. I authorize any holder of medical information about me to release to ${businessName} or its affiliates, my physician(s), caregiver, CMS, its agents and to my primary and/or other medical insurer any information needed to determine or secure eligibility information and/or reimbursement for covered services. I agree to pay all amounts that are not covered by my insurer(s) and for which I am responsible.

I accept delivery of the above equipment. I agree to pay all amounts that are not covered by my insurer(s) including applicable co-payments and/or deductibles for which I am responsible.
Attention all patients, since DMEOP products are medical in nature we will not be able to accept any items opened or otherwise used in any form or fashion. Please be aware, we have a No Refund policy on all purchased items.
I have read, received and/or been instructed in detail on the items checked above.`;
          },
          x: 13,
          y: 186,
          width: 190,
          fontSize: 7,
          lineHeight: 1.3,
        },
      ],
      fields: [
        {
          name: 'Type of delivery',
          type: 'radio',
          options: [
            {
              x: 146.5,
              y: 35.5,
              width: 2.5,
              height: 2,
              value: 'Y',
            },
            {
              x: 182,
              y: 35.5,
              width: 2.5,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 40,
          y: 38,
          width: 110,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientAddress,
          x: 40,
          y: 43,
          width: 110,
        },
        {
          name: 'Patient City',
          type: 'text',
          getValue: getPatientCity,
          x: 40,
          y: 48,
          width: 65,
        },
        {
          name: 'Patient State',
          type: 'text',
          getValue: getPatientState,
          x: 106,
          y: 48,
          width: 18,
        },
        {
          name: 'Patient Zip',
          type: 'text',
          getValue: getPatientZip,
          x: 126,
          y: 48,
          width: 24,
          normalize: normalize.zip,
        },
        {
          name: 'Alternate Contact',
          type: 'text',
          x: 40,
          y: 53,
          width: 110,
        },
        {
          name: 'Patient Date of Birth',
          type: 'text',
          getValue: getPatientFullDob,
          x: 164,
          y: 38,
          width: 41,
          normalize: normalize.date,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 164,
          y: 43,
          width: 41,
        },
        {
          name: 'Patient Phone',
          type: 'text',
          getValue: getPatientFullPhone,
          x: 164,
          y: 48,
          width: 41,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Patient Alt Phone',
          type: 'text',
          x: 164,
          y: 53,
          width: 41,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Insurance ID',
          type: 'text',
          getValue: getInsuranceID,
          x: 40,
          y: 61.5,
          width: 65,
        },
        {
          name: 'Physician Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 125,
          y: 61.5,
          width: 74,
        },
        {
          name: 'Not Delivered',
          type: 'checkbox',
          x: 174,
          y: 67,
          width: 2.5,
          height: 2.5,
        },
        {
          name: 'Safe 1',
          type: 'checkbox',
          x: 12.5,
          y: 74,
          width: 3,
          height: 3,
        },
        {
          name: 'Safe 2',
          type: 'checkbox',
          x: 50.5,
          y: 74,
          width: 3,
          height: 3,
        },
        {
          name: 'Appropriate for Home',
          type: 'radio',
          options: [
            {
              x: 114,
              y: 73.5,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 138,
              y: 74,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Alert & Understands Instructions',
          type: 'checkbox',
          x: 114,
          y: 77,
          width: 3,
          height: 3,
        },
        {
          name: 'Return Demonstration by Patient',
          type: 'checkbox',
          x: 114,
          y: 80.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Confused/Caregiver Instructed',
          type: 'checkbox',
          x: 114,
          y: 84,
          width: 3,
          height: 3,
        },
        {
          name: 'Personal/Physical Limit',
          type: 'text',
          x: 144,
          y: 86,
          width: 36,
        },
        {
          name: 'Copy of this form has been given to this patient/caregiver',
          type: 'checkbox',
          x: 114,
          y: 89.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Rights & Responsibilities',
          type: 'checkbox',
          x: 13.5,
          y: 100.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Service Availability of Company',
          type: 'checkbox',
          x: 13.5,
          y: 104,
          width: 2,
          height: 2,
        },
        {
          name: 'Privacy Notice',
          type: 'checkbox',
          x: 13.5,
          y: 107.5,
          width: 2,
          height: 2,
        },
        {
          name: '30 Medicare Supplier Standards',
          type: 'checkbox',
          x: 13.5,
          y: 111,
          width: 2,
          height: 2,
        },
        {
          name: 'Cleaning & Maintenance of Equipment',
          type: 'checkbox',
          x: 66.5,
          y: 100.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Capped Rental/Purchase Letter',
          type: 'checkbox',
          x: 66.5,
          y: 104,
          width: 2,
          height: 2,
        },
        {
          name: 'Complaint Process (how it is reviewed/resolved)',
          type: 'checkbox',
          x: 66.5,
          y: 107.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Warranty Information',
          type: 'checkbox',
          x: 66.5,
          y: 111,
          width: 2,
          height: 2,
        },
        {
          name: 'AOB Signature',
          type: 'checkbox',
          x: 137,
          y: 100.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Equipment Instructions',
          type: 'checkbox',
          x: 137,
          y: 104,
          width: 2,
          height: 2,
        },
        {
          name: 'Return Demonstration',
          type: 'checkbox',
          x: 137,
          y: 107.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Smoking Sign Placed At Door (For Oxygen Use)',
          type: 'checkbox',
          x: 137,
          y: 111,
          width: 2,
          height: 2,
        },
        {
          name: 'FOLLOW UP VISITS RECOMMENDED',
          type: 'checkbox',
          x: 102,
          y: 114,
          width: 3,
          height: 3,
        },
        {
          name: 'FOLLOW UP BY PHONE & AS NEEDED',
          type: 'checkbox',
          x: 163.5,
          y: 114,
          width: 3,
          height: 3,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7].reduce((accumulator, currentValue) => {
          const y = 124.5 + (currentValue * 6.35);
          return [
            ...accumulator,
            {
              name: `Serial/LOT ${currentValue}`,
              type: 'text',
              x: 13,
              y,
              width: 26,
            },
            {
              name: `HCPCS ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 40,
              y,
              width: 24,
              normalize: normalize.hcpcCode,
            },
            {
              name: `Description ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDescription({ ...props, index: currentValue }),
              x: 66,
              y,
              width: 69,
            },
            {
              name: `Brand/Model ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineModel({ ...props, index: currentValue }),
              x: 137,
              y,
              width: 32,
            },
            {
              name: `Charge ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineCharge({ ...props, index: currentValue }),
              x: 171,
              y,
              width: 12,
              normalize: normalize.price,
              chargeField: true,
            },
            {
              name: `Qty ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 186,
              y,
              width: 6,
              normalize: normalize.number,
            },
            {
              name: `Total Cost ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineTotalCharge({ ...props, index: currentValue }),
              x: 193.5,
              y,
              width: 13.5,
              normalize: normalize.price,
              chargeField: true,
            },
          ];
        }, []),
        {
          name: 'FINAL COST OR ADDITIONAL CO-PAY AMOUNTS',
          type: 'text',
          x: 158,
          y: 174,
          width: 13,
          getValue: props => getOrderTotalCharge({ ...props }),
          normalize: normalize.price,
          chargeField: true,
        },
        {
          name: 'Patient Signature',
          type: 'signature',
          getValue: getSignature,
          x: 18,
          y: 241,
          width: 90,
          height: 18,
        },
        {
          name: 'Drivers Name',
          type: 'text',
          getValue: props => getOrderLineDriverFullName({ ...props, index: 0 }),
          x: 114,
          y: 253.5,
          width: 63,
        },
        {
          name: 'Date of Delivery',
          type: 'text',
          getValue: getSignatureDate,
          x: 178,
          y: 253.5,
          width: 29,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketDeliveryInstructionsAndReceipt;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-Delivery-Instructions-And-Receipt-Old.js